import React from "react";
import { colors } from "../../constants/theme";
import type { AgentActivity } from "../../types";
import { Badge } from "../ui/Badge";

interface AgentActivityTableProps {
  activities: AgentActivity[];
}

const th: React.CSSProperties = { textAlign: "left", color: "#555", fontWeight: 700, fontSize: 12, padding: "4px 6px", borderBottom: `1px solid ${colors.border}` };
const td: React.CSSProperties = { color: colors.text, fontSize: 13, padding: "4px 6px", borderBottom: `1px solid ${colors.border}` };

export const AgentActivityTable: React.FC<AgentActivityTableProps> = ({ activities }) => (
  <div style={{ marginTop: 12 }}>
    <div style={{ color: colors.text, fontWeight: 700, marginBottom: 8 }}>Agent activity</div>
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          <th style={th}>Agent</th>
          <th style={th}>Kind</th>
          <th style={th}>Status</th>
          <th style={th}>Started</th>
          <th style={th}>Ended</th>
          <th style={th}>Notes</th>
        </tr>
      </thead>
      <tbody>
        {activities.length === 0 ? (
          <tr><td colSpan={6} style={{ ...td, color: colors.muted, textAlign: "center", padding: "12px 6px" }}>No activity yet</td></tr>
        ) : (
          activities.slice().reverse().map((a) => (
            <tr key={a.id}>
              <td style={td}>{a.agentName}</td>
              <td style={td}>{a.agentKind}</td>
              <td style={td}><Badge status={a.status} /></td>
              <td style={td}>{new Date(a.startedAt).toLocaleString()}</td>
              <td style={td}>{a.endedAt ? new Date(a.endedAt).toLocaleString() : "—"}</td>
              <td style={td}>{a.notes || "—"}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

